export const handleSelect = (name, value, passenger) => {
  let values = passenger.values;
  let errors = passenger.errors;

  values = { ...values, [name]: value };
  errors = { ...errors, [name]: "" };

  return { values, errors };
};
